<template>
  <div class="lotto-view">
    <div v-if="showLoading" class="lotto-loading">
      <lottie
        :options="defaultOptionsSplashScreen"
        :height="260"
        :width="260"
        @animCreated="handleAnimationSplashScreen"
      />
      <span>กำลังตรวจสอบสิทธิ์ของคุณ</span>
    </div>
    <div v-else>
      <headerSection />
      <main class="member-page lotto-page">
        <div class="member-page__content lotto-content">
          <MemberPageHeading
            eyebrow="Lucky number"
            title="ทายเลขรับเครดิต"
            subtitle="เลือกเลข 2 ตัวตามจำนวนสิทธิ์ ก่อนปิดรับในเวลาที่กำหนด"
          />

          <section class="member-card lotto-status-card" aria-label="จำนวนสิทธิ์แทงหวย">
            <div class="lotto-ticket-icon" aria-hidden="true">✦</div>
            <div class="lotto-ticket-copy">
              <small>สิทธิ์จากยอดฝากวันนี้</small>
              <strong>ฝากครบทุก 300 บาท</strong>
            </div>
            <div class="lotto-ticket-count">
              <strong>{{ displayCountQTY }}/{{ displayQTY }}</strong>
              <small>ใช้สิทธิ์แล้ว</small>
            </div>
            <div class="lotto-progress" aria-hidden="true">
              <span :style="{ width: `${lottoProgress}%` }" />
            </div>
          </section>

          <div v-if="!isShow" class="member-note member-note--gold">
            <span class="member-note__icon">i</span>
            <span>{{ QTY === 0 ? 'วันนี้ยังไม่มีสิทธิ์ หรือไม่ใช่วันที่เปิดกิจกรรม' : 'ขณะนี้ปิดรับการทายเลขแล้ว สามารถดูเลขที่บันทึกไว้ได้' }}</span>
          </div>

          <div class="member-section-head">
            <h2 class="member-section-head__title">เลือกเลขที่ชอบ</h2>
            <span class="member-section-head__meta">00 — 99</span>
          </div>
          <div class="lotto-number-grid">
            <template v-for="row in rows">
              <button
                v-for="column in 5"
                :key="`${row}-${column}`"
                type="button"
                :class="['lotto-number', { 'lotto-number--selected': huays[renderNumber(row, column - 1)] }]"
                :disabled="!isShow || isDisabled"
                @click="selectNumber(renderNumber(row, column - 1))"
              >
                {{ renderNumber(row, column - 1) }}
              </button>
            </template>
          </div>

          <div class="lotto-picked-bar">
            <div class="lotto-picked-list">
              <span v-if="!selectedNumbers.length" class="lotto-picked-empty">ยังไม่ได้เลือกหมายเลข</span>
              <span v-for="number in selectedNumbers" :key="number" class="lotto-picked-token">{{ number }}</span>
            </div>
            <button
              type="button"
              class="lotto-confirm"
              :disabled="!canConfirm"
              @click="confirm"
            >
              {{ buttonLabel }}
            </button>
          </div>

          <details class="member-rule lotto-rule">
            <summary class="member-rule__summary">ดูเงื่อนไขกิจกรรม</summary>
            <div class="member-rule__content">
              <ul class="member-rule-list">
                <li>ยอดฝาก 300 บาทขึ้นไป ได้รับ 1 สิทธิ์ในการทายเลข</li>
                <li>ทายรางวัลเลข 2 ตัวบน ถูกรับ 500 เครดิต ทำเทิร์น 2 เท่า</li>
                <li>ปิดรับการทายเวลา 15:00 น. ของวันที่หวยออก</li>
                <li>ต้องมีรายการเล่น 1 เทิร์นก่อนเวลา 16:00 น.</li>
                <li>เครดิตฟรีจะเพิ่มให้ภายในเวลา 19:00 น. ของวันที่หวยออก</li>
              </ul>
            </div>
          </details>
        </div>
      </main>
      <footerSection />
    </div>
  </div>
</template>
<script>
import firebase from '@/services/memberData'
import 'firebase/firestore'
import 'firebase/database'
import 'firebase/auth'
import 'firebase/functions'
import router from './../router'
import Lottie from './lottie.vue'
import * as animateSantaWalk from '../assets/loading.json'
import moment from 'moment-timezone'
require('vue2-animate/dist/vue2-animate.min.css')
// @ is an alias to /src
export default {
  name: 'Huay',
  components: {
    headerSection: () => import('./Header.vue'),
    footerSection: () => import('./Footer.vue'),
    lottie: Lottie,
    MemberPageHeading: () => import('../components/member/MemberPageHeading.vue')
  },
  created () {
    const user = localStorage.getItem('userData')
    if (user) {
      const _user = JSON.parse(user)
      this.$store.dispatch('user/setUser', _user).then(async () => {
        const huay = (await firebase.database().ref('/huay').once('value')).val() || []
        const dateHuay = []
        for (const x in huay) {
          dateHuay.push(Number(huay[x]))
        }
        if (dateHuay.includes(Number(moment().tz('Asia/Bangkok').format('D')))) {
          if (Number(moment().tz('Asia/Bangkok').format('H') + '' + moment().tz('Asia/Bangkok').format('mm')) <= 1520) {
            this.calculate()
            this.isShow = true
          } else {
            this.calculate()
          }
        } else {
          this.QTY = 0
          this.countQTY = 0
        }
      }).catch(err => { console.error(err) })
    } else {
      firebase.auth().signOut()
      localStorage.removeItem('userData')
      router.replace('/login')
    }
    const animateSplashScreen = animateSantaWalk.default
    this.defaultOptionsSplashScreen = { animationData: animateSplashScreen, autoplay: false, loop: false }
  },
  computed: {
    user () {
      return this.$store.state.user.user
    },
    selectedNumbers () {
      return Object.keys(this.huays).filter(number => this.huays[number]).slice(0, this.rows * 5)
    },
    displayQTY () {
      return typeof this.QTY === 'number' ? this.QTY : '—'
    },
    displayCountQTY () {
      return typeof this.countQTY === 'number' ? this.countQTY : '—'
    },
    lottoProgress () {
      if (typeof this.QTY !== 'number' || !this.QTY || typeof this.countQTY !== 'number') return 0
      return Math.min((this.countQTY / this.QTY) * 100, 100)
    },
    canConfirm () {
      return this.isShow && !this.isDisabled && this.selectedNumbers.length > 0 && this.selectedNumbers.length <= this.QTY
    }
  },
  mounted () {
        this.animSplashScreen.play()
        setTimeout(() => {
            this.showLoading = false
            this.animSplashScreen.stop()
            // setTimeout(() => {
            //   this.canvas = document.getElementById('canvas')
            //   this.repaint(this.angle)
            // }, 500)
        }, 3500)
      //this.getGames()
  },
  data () {
    return {
      isShow: false,
      huays: {},
      rows:20,
      logoLeft: '',
      logoRight: '',
      angle: 0,
      gameKey: 'spin',
      showLoading: true,
      pictureUrl: '',
      code: '',
      games_web: [],
      search: '',
      loading: false,
      error: false,
      web: [],
      message: 'Invalid user name or password!',
      point: 0,
      favorites: [],
      animationInfinite: {
        classes: 'fadeIn',
        duration: 5000,
        iteration: 'infinite'
      },
      buttonLabel:'ยืนยันแทงหวย',
      permission: [],
      defaultOptions: null,
      defaultOptions2: null,
      defaultOptionsSplashScreen: null,
      openGiftData: false,
      canOpen: false,
      percentage: 0,
      loadingtext: '',
      credit: '',
      save: false,
      canvas: null,
      frame: null,
      wheels: null,
      sections: [],
      sectionspoint: [],
      colors: [],
      percent: [],
      isDisabled: false,
      QTY:'loading',
      countQTY:'loading',
    }
  },
  methods: {
    calculate(){
        firebase.firestore().collection('krungsri').where('date', '>=', moment().tz("Asia/Bangkok").format("YYYY-MM-DD")+' 00:00:00').where('type','==','ฝาก').where('status','==','ดำเนินการแล้ว').where('userkey','==',this.user.key).get().then((snapshot)=>{
            let deposit = 0;
            snapshot.forEach((doc)=>{
                deposit += (Number(doc.data().qty.toString().replace(',','')));
            });
            const qty = Math.floor(deposit/300);
            this.QTY = qty;
            if(qty){
            firebase.firestore().collection('huays').doc(this.user.key+'-'+moment().tz("Asia/Bangkok").format("YYYY-MM-DD")).get().then((doc)=>{
                if(doc.exists){
                    this.countQTY = 0;
                    if(doc.data().huays){
                        for(const x in doc.data().huays){
                            const xx = doc.data().huays[x];
                            this.$set(this.huays, xx, true);
                        }
                        this.countQTY = doc.data().huays.length;
                    }
                }else{
                    this.countQTY = 0;
                }
            });
            }else{
              this.countQTY = 0;
            }
    });
    },
    selectNumber(num){
        if(typeof this.countQTY == 'number' && typeof this.QTY == 'number' && this.isShow && !this.isDisabled){
            if(this.huays[num]){
                this.$delete(this.huays, num)
                this.countQTY--
            }else if(this.QTY > this.countQTY){
                this.$set(this.huays, num, true)
                this.countQTY++
            }
        }
    },
    async confirm() {
        if (this.isDisabled) return;
        if(this.canConfirm){
            this.buttonLabel = 'loading...';
            this.isDisabled = true;
            const huays = this.selectedNumbers.slice();
            // เรียกใช้ Cloud Function แทนการเขียน Firestore โดยตรง
            try {
              const saveHuay = firebase.functions().httpsCallable('saveHuay');
              const result = await saveHuay({
                huays,
                userkey: this.user.key
              });
              if (!result.data || result.data.success !== true) {
                alert((result.data && result.data.message) || 'ไม่สามารถบันทึกหมายเลขได้ กรุณาตรวจสอบสิทธิ์แล้วลองใหม่อีกครั้ง');
                return;
              }
              this.$confirm({
                message: 'แทงหวยเรียบร้อยแล้วค่ะ 😘',
                button: { yes: 'OK' }
              });
            } catch (error) {
                console.error('Error saving huay:', error.code);
                const messages = {
                  'functions/unauthenticated': 'กรุณาเข้าสู่ระบบใหม่ แล้วยืนยันหมายเลขอีกครั้ง',
                  'functions/permission-denied': 'ไม่สามารถยืนยันสิทธิ์บัญชีได้ กรุณาเข้าสู่ระบบใหม่',
                  'functions/invalid-argument': 'กรุณาเลือกเลข 2 ตัว ตั้งแต่ 00 ถึง 99 โดยไม่ซ้ำกัน',
                  'functions/failed-precondition': 'ระบบรับแทงได้เฉพาะ 00:00 - 15:20 เท่านั้น'
                };
                alert(messages[error.code] || 'เกิดข้อผิดพลาดในการบันทึกข้อมูล กรุณาลองใหม่อีกครั้ง');
            } finally {
                this.isDisabled = false;
                this.buttonLabel = 'ยืนยันแทงหวย';
            }
        }else{
          alert('โปรดตรวจสอบสิทธิ์จำนวนที่แทง');
        }
    },
    renderNumber(row,i){
        const num = ((row-1)*5)+i;
        if(num.toString().length == 1){
            return '0'+num;
        }else{
            return num.toString();
        }
    },
    handleAnimationSplashScreen: function (anim) {
      this.animSplashScreen = anim
    },
    checkCssBox (game) {
      if (!game.status) {
        return 'box-shadow: 0 0 12px 5px #cccccc;border: 2px solid #cccccc;'
      }
    },
    checkCss (game) {
      if (!this.permission || !this.permission[game.key]) {
        return 'filter: grayscale(100%);'
      }
      // const index = _.findIndex(this.favorites, function(o) { return o == code; });
      // if (index>-1) {
      //   return '';
      // } else {
      //   return 'filter: grayscale(100%);';
      // }
    },
    goto (type) {
      if (type === 'home') {
        // window.scrollTo({
        //   top: 0,
        //   left: 0,
        //   behavior: 'smooth'
        // });
        this.$router.push('/').catch(() => {})
      } else if (type === 'website') {
        window.location = this.web.link
        // this.gotoline()
      } else if (type === 'contact') {
        window.location = this.web.link_line
        // this.gotoline()
      }
    },
  }
}
</script>
<style scoped>
.glow {
    color: #fff;
    text-align: center;
    -webkit-animation: glow 1s ease-in-out infinite alternate;
    -moz-animation: glow 1s ease-in-out infinite alternate;
    animation: glow 1s ease-in-out infinite alternate;
    }

    @-webkit-keyframes glow {
    from {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
    
    to {
        text-shadow: 0 0 10px #dbc47a, 0 0 20px #dbc47a, 0 0 30px #dbc47a, 0 0 40px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a, 0 0 10px #dbc47a;
    }
}
.center {
    position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
#contact_gl {
  min-height: 600px;
  color: #333;
  width: 100%;
  min-height: 100vh;
  display: -webkit-box;
  display: -webkit-flex;
  display: -moz-box;
  display: -ms-flexbox;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  position: relative;
  z-index: 1;
	/*background: -moz-radial-gradient(center, ellipse cover, #f7f7f7 0%, #d1d1d1 100%);
	background: -webkit-radial-gradient(center, ellipse cover, #f7f7f7 0%,#d1d1d1 100%);
	background: radial-gradient(ellipse at center, #f7f7f7 0%,#d1d1d1 100%);
	filter: progid:DXImageTransform.Microsoft.gradient( startColorstr='#f7f7f7', endColorstr='#d1d1d1',GradientType=1 );*/
}
#contact_gl::before {
  content: "";
  display: block;
  position: absolute;
  z-index: -1;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  opacity: 0.9;
}
.boxlogin {
    background: #fff;
    overflow: hidden;
    width: 100%;
    height: 100%;
    border-radius: 2px;
    box-shadow: 0 0 40px #000;
    color: #8b8c8d;
    font-size: 0;
}
.boxlogin .box-part {
    display: inline-block;
    position: relative;
    vertical-align: top;
    height: 100%;
}
.boxlogin, .box .box-part {
    box-sizing: border-box;
}
.boxlogin .partition {
    width: 100%;
    height: 100%;
}
.boxlogin .partition .partition-title {
    box-sizing: border-box;
    padding: 30px;
    width: 100%;
    text-align: center;
    letter-spacing: 1px;
    font-size: 20px;
    font-weight: 300;
}
.boxlogin .partition .partition-form {
    padding: 0 20px;
    box-sizing: border-box;
}
.boxlogin .button-set {
    margin-bottom: 8px;
}
.boxlogin .github-btn {
    border-color: #dba226;
    color: #dba226;
}
.boxlogin .large-btn {
    width: 100%;
    background: #fff;
}
.boxlogin button {
    background: #fff;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 10px;
    letter-spacing: 1px;
    font-family: Open Sans,sans-serif;
    font-weight: 400;
    min-width: 140px;
    margin-top: 8px;
    color: #8b8c8d;
    cursor: pointer;
    border: 1px solid #dddedf;
    text-transform: uppercase;
    transition: all .1s;
    font-size: 10px;
    outline: none;
}
a.button1{
    display:inline-block;
    padding:0.35em 1.2em;
    border:0.1em solid #FFFFFF;
    margin:0 0.3em 0.3em 0;
    border-radius:0.12em;
    box-sizing: border-box;
    text-decoration:none;
    font-weight:300;
    text-align:center;
    transition: all 0.2s;
    text-decoration: none;
    font-size: 15px;
    width: 70px;
}
.active{
    color:#000000 !important;
    background-color:#FFFFFF !important;
    text-decoration: none !important;
}
div.rowClass {
    flex-direction: row;
    justify-content: space-around;
    display: flex;
}
@media all and (max-width:30em){
    a.button1{
        margin:0.4em auto;
    }
}
.btn2 {
    width: 100%;
    font-size: 15px;
    border-radius: 25px;
    color: #fff;
    border: none;
    padding: .7rem 1.5rem;
    min-width: 180px;
    background: linear-gradient(180deg,#91f27f 10%,#00b302);box-shadow: 0 2px 4px rgb(0 0 0 / 12%), 0 1px 2px hsl(0deg 7% 92% / 24%);
}
 .p2 {
	 letter-spacing: 0;
	 text-shadow: 0 0 80px rgba(255, 255, 255, .5);
	/* Clip Background Image */
	 background: url(https://i.ibb.co/RDTnNrT/animated-text-fill.png) repeat-y;
	 -webkit-background-clip: text;
	 background-clip: text;
	/* Animate Background Image */
	 -webkit-text-fill-color: transparent;
	 -webkit-animation: aitf 80s linear infinite;
	/* Activate hardware acceleration for smoother animations */
	 -webkit-transform: translate3d(0, 0, 0);
	 -webkit-backface-visibility: hidden;
}
/* Animate Background Image */
 @-webkit-keyframes aitf {
	 0% {
		 background-position: 0% 50%;
	}
	 100% {
		 background-position: 100% 50%;
	}
}
</style>
<style scoped>
.lotto-loading {
  min-height: 100vh;
  display: grid;
  place-content: center;
  justify-items: center;
  color: #8793aa;
  background:
    radial-gradient(circle at 50% 40%, rgba(47, 123, 255, .16), transparent 22rem),
    #05070c;
  font-family: 'Kanit', sans-serif;
  font-size: 12px;
}

.lotto-content {
  width: min(100%, 820px);
}

.lotto-status-card {
  padding: 16px 16px 20px;
  display: grid;
  grid-template-columns: 46px minmax(0, 1fr) auto;
  align-items: center;
  gap: 13px;
}

.lotto-ticket-icon {
  width: 46px;
  height: 46px;
  display: grid;
  place-items: center;
  border-radius: 15px;
  color: #ffca52;
  background: rgba(255, 202, 82, .09);
  font-size: 19px;
}

.lotto-ticket-copy {
  min-width: 0;
}

.lotto-ticket-copy small,
.lotto-ticket-count small {
  display: block;
  color: #8793aa;
  font-size: 9px;
}

.lotto-ticket-copy strong {
  display: block;
  margin-top: 3px;
  color: #f7faff;
  font-size: 14px;
  font-weight: 500;
}

.lotto-ticket-count {
  text-align: right;
}

.lotto-ticket-count strong {
  color: #ffca52;
  font-size: 22px;
  font-weight: 600;
}

.lotto-progress {
  height: 4px;
  grid-column: 1 / -1;
  overflow: hidden;
  border-radius: 99px;
  background: #192335;
}

.lotto-progress span {
  height: 100%;
  display: block;
  border-radius: inherit;
  background: linear-gradient(90deg, #ffca52, #ff9f32);
  transition: width .25s ease;
}

.lotto-number-grid {
  display: grid;
  grid-template-columns: repeat(5, minmax(0, 1fr));
  gap: 8px;
}

.lotto-number {
  aspect-ratio: 1;
  border: 1px solid rgba(117, 143, 185, .2);
  border-radius: 13px;
  color: #d9e1ef;
  background: linear-gradient(145deg, #101827, #0a101b);
  font-family: 'Kanit', sans-serif;
  font-size: 13px;
  cursor: pointer;
  transition: border-color .16s ease, background .16s ease, color .16s ease, transform .16s ease;
}

.lotto-number:hover:not(:disabled) {
  border-color: #5188ef;
  transform: translateY(-1px);
}

.lotto-number--selected,
.lotto-number--selected:disabled {
  border-color: #ffca52;
  color: #261800;
  background: linear-gradient(145deg, #ffe39b, #ffbd35);
  box-shadow: 0 7px 16px rgba(255, 186, 44, .16);
  font-weight: 600;
  opacity: 1;
}

.lotto-number:disabled:not(.lotto-number--selected) {
  opacity: .42;
  cursor: not-allowed;
}

.lotto-picked-bar {
  position: sticky;
  z-index: 10;
  bottom: 76px;
  margin-top: 14px;
  padding: 11px 12px;
  display: flex;
  align-items: center;
  gap: 8px;
  border: 1px solid rgba(88, 136, 228, .25);
  border-radius: 17px;
  background: rgba(9, 15, 26, .94);
  box-shadow: 0 15px 35px rgba(0, 0, 0, .45);
  backdrop-filter: blur(18px);
}

.lotto-picked-list {
  min-width: 0;
  flex: 1;
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
}

.lotto-picked-token {
  width: 28px;
  height: 28px;
  display: grid;
  place-items: center;
  border-radius: 9px;
  color: #211600;
  background: #ffca52;
  font-size: 10px;
  font-weight: 600;
}

.lotto-picked-empty {
  align-self: center;
  color: #8793aa;
  font-size: 9px;
}

.lotto-confirm {
  min-width: 96px;
  height: 40px;
  padding: 0 14px;
  border: 0;
  border-radius: 11px;
  color: #fff;
  background: #2e79fb;
  font-family: 'Kanit', sans-serif;
  font-size: 10px;
  cursor: pointer;
}

.lotto-confirm:disabled {
  color: #647084;
  background: #1b2433;
  cursor: not-allowed;
}

.lotto-rule {
  margin-top: 12px;
}

@media (min-width: 768px) {
  .lotto-number-grid {
    grid-template-columns: repeat(10, minmax(0, 1fr));
  }
}

@media (max-width: 360px) {
  .lotto-number-grid { gap: 6px; }
  .lotto-number { border-radius: 11px; font-size: 12px; }
  .lotto-picked-bar { padding: 9px; }
  .lotto-confirm { min-width: 82px; padding: 0 10px; }
}
</style>
